import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/failedPaymentProcessesMoreInfoModal";
import deltas from "../../actions/deltas";

const {SET_FAILED_PAYMENT_PROCESSES_MORE_INFO_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_FAILED_PAYMENT_PROCESSES_MORE_INFO_MODAL_STATE);

export const selectFailedPaymentProcessesMoreInfoModalState = state => state.states.failedPaymentProcessesMoreInfoModal.state;
